<template>
  <v-row dense justify="center" align="center">
    <v-col cols="12" sm="6">
      <v-expansion-panels outlined v-model="panel_open">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:actions>
              <v-icon color="primary"> $expand </v-icon>
            </template>
            <template v-slot:default="{ open }">
              <v-row no-gutters align="center">
                <v-col cols="8">
                  <v-row dense no-gutters align="center">
                    <v-col cols="auto">
                      <v-icon class="mr-2" color="black">
                        mdi-shopping-search
                      </v-icon>
                    </v-col>
                    <v-col cols="9">
                      <strong>
                        {{ $t("messanger.dash.filters.Tracking.name") }}
                      </strong>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open" key="0">
                      {{
                        $t(
                          "messanger.dash.filters.Bot_Human_mode.select_choise"
                        )
                      }}
                    </span>
                    <span v-else key="1">
                      {{ cart ? $t(`messanger.dash.table_head.product`) : "" }}
                      {{
                        purchase
                          ? ` , ${$t(`messanger.dash.table_head.purchase`)}`
                          : ""
                      }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense justify="center" align="center">
              <v-col cols="12" sm="6">
                <v-row dense justify="center" align="center">
                  <v-col cols="auto" md="6">
                    <v-checkbox
                      v-model="cart"
                      :label="$t(`messanger.dash.table_head.product`)"
                      color="cleed_blue"
                      :value="true"
                      hide-details
                      @change="Onchange('cart')"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="auto" md="6">
                    <v-checkbox
                      v-model="purchase"
                      :label="$t(`messanger.dash.table_head.purchase`)"
                      color="cleed_blue"
                      :value="true"
                      hide-details
                      @change="Onchange('purchase')"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Tracking.vue",
  data() {
    return {
      panel_open: false,
      cart: false,
      purchase: false,
    };
  },
  computed: {
    state() {
      const data = this.$store.state.ui.msgTrackingState;
      return data;
    },
  },
  mounted() {
    this.cart = this.state.cart;
    this.purchase = this.state.purchase;
  },
  methods: {
    async Onchange(elem) {
      this.$store.state.messages.loading = true;
      if (elem == "cart")
        this.$store.dispatch("SET_TRACKING", { elem, value: !!this.cart });
      else
        this.$store.dispatch("SET_TRACKING", { elem, value: !!this.purchase });
      if (this.$store.state.ui.msgTrackingState.cart) {
        await this.$store
          .dispatch("FETCH_PRODUCT_ADDED_TO_CART")
          .then((data) => {
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (this.$store.state.ui.msgTrackingState.purchase) {
        await this.$store
          .dispatch("FETCH_PRODUCT_PURCHASE")
          .then((data) => {
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      await this.$store
        .dispatch("FETCH_MESSAGES", {
          page: 0,
          type: this.$store.state.messanger_type_selected,
        })
        .then((r) => {
          this.$store.state.messages.api_msg_pull = 0;
          this.$store.state.messages.loading = false;
          this.$store.state.messages.last_page = 1;
        });
      this.$store.dispatch("setCloader", { showing: true });
      this.$store.dispatch("CONVERSATION_LENGHT").then((r) => {
        this.$store.dispatch("setCloader", { showing: false });
      });
    },
  },
};
</script>
